import { useEffect, useState } from 'react';

export function useQueryParams() {
  const [ page, setPage ] = useState(0);
  const [ limit, setLimit ] = useState(10);
  const [ sort, setSortAux ] = useState({ order: 'desc', orderBy: 'updated_at' });

  const setSort = (property, ascDesc) => {
    setSortAux({ order: ascDesc, orderBy: property });
  };

  useEffect(() => {
    setPage(0);
  }, [ limit ]);

  return {
    page,
    setPage,
    limit,
    setLimit,
    sort,
    setSort,
  };
}
